export const truncateText = (text: string, maxLength: number = 10) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};